import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const Quit = async () => {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/logout`, {

            method: 'GET',
            credentials: 'include', // Cookie otomatik gider
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )
        window.location.href = "/";
    };
    const [user, setUser] = useState(null);
        useEffect(() => {
        let isFetching = false; // Prevent multiple fetches
        const fetchUser = async () => {
            if (isFetching) return; // Skip if already fetching
            isFetching = true;

            try {

    const response =await fetch(`${process.env.REACT_APP_BACKEND_URL}/userinf/userauth`, {
  method: "GET",
  credentials: "include"
});

    
    if (response.status === 401) {
        setUser(null); // Yetkisiz ise kullanıcıyı sıfırla
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    setUser(data);

} catch (error) {
    console.error("Failed to fetch user:", error);
} finally {
    isFetching = false; // Reset fetching state
}

        };

        fetchUser();
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleUserClick = () => {
        if (user) {
            switch (user.user_type) {
                case "company":
                    window.location.href = "/isletme";
                    break;
                case "kormy":
                    window.location.href = "/Myardyonetim";
                    break;
                case "teacher":
                    window.location.href = "/guest/home";
                    break;
                case "student":
                    window.location.href = "/OgrenciGenel";
                    break;
                default:
                    console.error("Unknown user type");
            }
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo">
                    <i className="fas fa-graduation-cap"></i>
                    Staj Defterim
                </Link>
                
                <div className="menu-icon" onClick={toggleMenu}>
                    <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
                </div>
                
                <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
                    <li className="nav-item">
                        <Link to="/" className="nav-links">
                            Ana Sayfa
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/dersler" className="nav-links">
                            Dersler
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/kaynaklar" className="nav-links">
                            Kaynaklar
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/is-ilanlari" className="nav-links">
                            İş İlanları
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/hakkimizda" className="nav-links">
                            Hakkımızda
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/iletisim" className="nav-links">
                            İletişim
                        </Link>
                    </li>
                </ul>
                
                <div className="nav-links-mobile">
                    {user ? (
                        
                        <Link to="/">
                            <button className="btn-quit" onClick={Quit}>Çıkış Yap</button>
                        </Link>
                    ) : (
                        <Link to="/Giris">
                            <button className="btn">Giriş Yap</button>
                        </Link>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;